import React, { useState } from "react";
import styles from "./Slide4.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../Introduction.messages";
import { Button } from "@src/lms/jelly/extensions/ui";
import { FeatureComparisonModal } from "../modals/FeatureComparisonModal";
export const Slide4: React.FC = () => {
  const { formatMessage } = useIntl();

  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <div className={styles.slide4}>
      <h2 className={styles.title}>{formatMessage(messages.slide4Title)}</h2>
      <div className={styles.content}>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide4Title1)}</h3>
          <p>{formatMessage(messages.slide4Description1)}</p>
        </div>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide4Title2)}</h3>
          <p>{formatMessage(messages.slide4Description2)}</p>
        </div>
        <div className={styles.contentItem}>
          <h3>{formatMessage(messages.slide4Title3)}</h3>
          <p>{formatMessage(messages.slide4Description3)}</p>
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button className={styles.button} shape="round" onClick={() => setIsModalVisible(true)} icon="cil-chart-table">
          {formatMessage(messages.slide4Button)}
        </Button>
      </div>
      <FeatureComparisonModal visible={isModalVisible} onClose={() => setIsModalVisible(false)} />
    </div>
  );
};
